import { cn } from "@utils/tw"
import { ComponentPropsWithoutRef, forwardRef } from "react"

export const FooterCTA = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<"div">>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "my-3 bg-yellow p-6 rounded-md flex gap-6 justify-between items-center flex-col",
      "[&>button]:grow [&>button]:whitespace-nowrap [&>button]:w-full",
      "[&>a]:grow [&>a]:whitespace-nowrap [&>a]:w-full",
      "md:my-7 md:flex-row md:[&>button]:w-auto md:[&>a]:w-auto",
      className,
    )}
    {...props}
  />
))
FooterCTA.displayName = "FooterCTA"
